"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormComboBoxOptions", {
    enumerable: true,
    get: function() {
        return FormComboBoxOptions;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormComboBoxContext = require("../FormComboBoxContext");
const _ListGroup = /*#__PURE__*/ _interop_require_wildcard(require("../../../ListGroup"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormComboBoxOptions = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { highlightColor, ...props } = param;
    const combo = (0, _react.useContext)(_FormComboBoxContext.FormComboBoxContext);
    var _props_noBorder;
    return /*#__PURE__*/ _react.default.createElement(_ListGroup.Group, {
        ...props,
        noBorder: (_props_noBorder = props.noBorder) !== null && _props_noBorder !== void 0 ? _props_noBorder : true,
        ref: ref
    }, combo.items.map((item, i)=>/*#__PURE__*/ {
        var _item_el;
        return _react.default.createElement(_ListGroup.Item, {
            onClick: ()=>{
                combo.setSelected(i);
                combo.setFocused(false);
            },
            onMouseOver: ()=>{
                combo.setHighlighted(i);
            },
            key: i,
            ref: combo.itemRefs[i],
            noMargin: true,
            highlighted: combo.highlighted === i,
            highlightColor: highlightColor,
            noBorder: props.noBorder
        }, (_item_el = item.el) !== null && _item_el !== void 0 ? _item_el : item.value);
    }));
});
FormComboBoxOptions.displayName = "FormComboBoxOptions";

//# sourceMappingURL=FormComboBoxOptions.js.map